import { refreshStoredIssuedPurchaseOrderPdf } from "@/components/manufacturing/issuePurchaseOrderAndDownloadPdf";
import {
  finalizeManufacturingPurchaseOrder,
  type MfgPurchaseOrder,
} from "@/lib/manufacturing/purchaseOrderClient";

type Msg = { text: string; ok: boolean };

/** Save the open PO, then lock materials and amounts. */
export async function finalizePurchaseOrder(input: {
  active: MfgPurchaseOrder | null;
  saveDraft: () => Promise<MfgPurchaseOrder | null>;
  plantName: string | undefined;
  setBusy: (busy: boolean) => void;
  setActive: (order: MfgPurchaseOrder) => void;
  setMsg: (msg: Msg) => void;
  loadLists: () => void;
}): Promise<void> {
  if (!input.active) {
    input.setMsg({ text: "Save the purchase order before finalizing.", ok: false });
    return;
  }
  const label = input.active.po_number || "this purchase order";
  if (
    !window.confirm(
      `Finalize PO ${label}? Materials and amounts cannot be changed after this.`
    )
  ) {
    return;
  }
  const saved = await input.saveDraft();
  if (!saved) return;
  input.setBusy(true);
  const res = await finalizeManufacturingPurchaseOrder(saved.id);
  input.setBusy(false);
  if (!res.ok) {
    input.setMsg({ text: res.error, ok: false });
    return;
  }
  const order = {
    ...res.data.order,
    lines: res.data.order.lines ?? saved.lines,
  };
  input.setActive(order);
  input.loadLists();
  if (order.status !== "draft") {
    const stored = await refreshStoredIssuedPurchaseOrderPdf({
      order,
      plantName: input.plantName,
    });
    if (!stored.ok) {
      input.setMsg({
        text: `Finalized PO ${order.po_number}, but the stored PDF was not refreshed. ${stored.error}`,
        ok: false,
      });
      return;
    }
  }
  input.setMsg({
    text: `Finalized PO ${order.po_number}. Materials and amounts are locked.`,
    ok: true,
  });
}
